<script lang="ts">
	import { goto } from '$app/navigation';
	import Button from '$lib/components/Button.svelte';
	import type { PageData } from './$types';
	import { downloadImage } from '$lib/utils/downloadImage';
	export let data: PageData;
</script>

<div class="flex flex-col items-center mx-4 desktop:mx-0">
	<div
		class="flex flex-col w-full pt-3 desktop:py-8 pb-5 space-y-1 desktop:space-y-3 border-b-[1px] border-gray-100"
	>
		<div class="text-h5 desktop:text-[24px]">{data.notice.title}</div>
		<div class="flex text-gray-400 text-body-medium">
			<span>작성일</span>
			<div class="divider" />
			<span>{data.notice.createdAt.slice(0, 10)}</span>
		</div>
	</div>
	<div class="flex flex-col w-full mt-3 space-y-2 desktop:space-y-3">
		{#if data.notice.fileUrls && data.notice.fileUrls.length > 0}
			<div class="text-h6 desktop:text-h5">관련 자료 다운로드</div>
			<div class="flex flex-wrap w-full gap-1 desktop:space-x-2">
				{#each data.notice.fileUrls as file}
					<button
						on:click={() => {
							if (file) {
								downloadImage(file, file.split('/').pop() || '다운로드');
							}
						}}
						class="flex items-center px-4 shrink-0 text-primary-200 border-[1px] border-primary-200 rounded-[100px] w-fit text-h6 h-10 cursor-pointer space-x-1"
					>
						<div>{decodeURIComponent(file.split('/').pop() ?? '다운로드')}</div>
						<img src="/primary/download.svg" alt="" class="w-[18px] h-[18px]" />
					</button>
				{/each}
			</div>
		{/if}
	</div>

	<div
		class="rounded-[8px] mb-2 border-[1px] border-gray-100 px-5 desktop:px-8 py-6 desktop:py-7 mt-8 desktop:mt-9 whitespace-pre-wrap w-full"
	>
		{@html data.notice.content}
	</div>

	<Button
		on:click={() => goto('/notice')}
		class="!px-6 !w-fit !rounded-full !h-12 mb-[36px]  desktop:mb-[96px]"
		text="목록으로"
	/>
</div>

<style lang="postcss">
	.divider {
		@apply w-[1px] mx-1 h-2 bg-gray-300 my-auto;
	}
</style>
